import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { idFromObject } from '@sorare/core/src/gql/idFromObject';
import { useGenerateDialogPath } from '@sorare/core/src/hooks/navigation/useGenerateDialogPath';

import { DumbNotification } from '#src/components/activity/DumbNotification/index.tsx';
import { commonNotificationInterfaceFragment } from '#src/components/activity/Notification/fragments.ts';
import type { CommonNotificationProps } from '#src/components/activity/Notification/types.ts';

import type { AnnouncementNotification_announcementNotification } from './__generated__/index.graphql.ts';

type Props = CommonNotificationProps & {
  notification: AnnouncementNotification_announcementNotification;
};

export const AnnouncementNotification = ({ notification, ...rest }: Props) => {
  const {
    createdAt,
    name,
    announcement: { id, title, url, logoUrl },
    sport,
    read,
  } = notification;
  const generateDialogPath = useGenerateDialogPath();

  return (
    <DumbNotification
      name={name}
      title={title}
      link={url || generateDialogPath(DialogKey.news, idFromObject(id))}
      createdAt={createdAt}
      sport={sport}
      read={read}
      avatarUrl={logoUrl}
      {...rest}
    />
  );
};

AnnouncementNotification.fragments = {
  announcementNotification: gql`
    fragment AnnouncementNotification_announcementNotification on AnnouncementNotification {
      id
      ...Notification_notificationInterface
      announcement {
        id
        title
        url
        logoUrl(derivative: "avatar")
      }
    }
    ${commonNotificationInterfaceFragment}
  ` as TypedDocumentNode<AnnouncementNotification_announcementNotification>,
};
